<template>
  <div class="uni-real-test allTest">
    <div class="real-test-filter">
      <Title text="练习中心" />

      <!-- tab -->
      <div class="titleTab">
        <el-tabs v-model="type_id" @tab-click="setTypeId">
          <el-tab-pane
            v-for="(item, index) in TestTypeList"
            :key="index"
            :label="item.title"
            :name="item.id + ''"
          >
          </el-tab-pane>
        </el-tabs>
      </div>

      <!-- filter-box -->
      <div class="box filter-box">
        <ul class="filter-list">
          <li class="item" v-if="type_name != '章节练习'">
            <span class="tit">课程类型</span>
            <div class="con">
              <el-radio-group @change="courseTypeChange" v-model="course_type">
                <el-radio
                  class="radio"
                  v-for="(item, index) in courseTypeList"
                  :label="item.course_type"
                  :value="item.id"
                  :key="index"
                  >{{ item.title }}</el-radio
                >
              </el-radio-group>
            </div>
          </li>
          <li class="item">
            <span class="tit">课程选择</span>
            <div class="con" style="margin-top: -5px">
              <el-button
                class="course mab20"
                size="mini"
                round
                v-for="item in selectList"
                :class="item.id === course_id ? 'active' : ''"
                :key="item.id"
                @click="courseSelect(item.id)"
                >{{ item.title }}
              </el-button>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div id="real-test-box" class="real-test-box">
      <!-- 历年真题、模拟考试 -->
      <div v-if="type_name !== '章节练习' && type_name !== '智能练习'">
        <ul class="real-test-list">
          <li class="item" v-for="item in paperLists.list" :key="item.id">
            <div class="img-box"></div>
            <div class="content">
              <p class="tit">
                {{ item.title }}
              </p>
              <p class="info">
                <span
                  ><i class="iconfont iconjilu"></i>考试时长：{{
                    item.duration
                  }}分钟</span
                >
                <span
                  ><i class="iconfont iconkecheng"></i>共计：{{
                    item.questionNum
                  }}道题</span
                >
                <span
                  ><i class="iconfont iconfenshijuan"></i>总分：{{
                    item.total_score
                  }}分</span
                >
              </p>
            </div>
            <div class="mar50" style="width: 200px">
              <span v-if="item.is_test === 1" class="green">已做过</span>
              <span v-if="item.is_test === 0" class="primary">未做过</span>
            </div>
            <el-button type="primary" class="test-btn" @click="jump(item.id)"
              >开始练习测试</el-button
            >
          </li>
        </ul>
        <!-- empty -->
        <ComponentEmpty
          v-if="paperLists.total === 0"
          title="暂无考试试卷"
          tips=""
        />
      </div>

      <!-- 章节练习 -->
      <div v-if="type_name == '章节练习'">
        <Practice :courseUuid="course_id" />
      </div>

      <!--智能练习 -->
      <div class="smart" v-if="type_name == '智能练习'">
        <div class="smartTab">
          <el-button
            v-for="(item, index) in smartBnt"
            :key="index"
            :class="setSmartActive == item.smartActive ? 'test-btn' : 'tab-btn'"
            @click="setSmartType(item.smartActive)"
            >{{ item.bntText }}</el-button
          >
        </div>

        <!-- 按照题型练习 -->
        <div class="real-test-list" v-if="setSmartActive === 'orderly'">
          <el-collapse accordion>
            <el-collapse-item
              v-for="(item, index) in smartDataList"
              :key="index"
            >
              <template slot="title">
                <li class="item">
                  <div class="img-box1">
                    <p></p>
                    <span>{{ item.title.slice(0, 1) }}</span>
                  </div>
                  <div class="content">
                    <p class="tit">
                      {{ item.title.slice(0, -2) }}
                    </p>
                    <p class="info">
                      <span>共{{ item.total }}题</span>
                      <!--<span>已做{{ item.make }}题</span>
                      <span
                        >已做正确率
                        {{
                          item.total
                            ? parseInt((item.correct / item.total) * 100)
                            : 0
                        }}%</span
                      >-->
                    </p>
                  </div>
                </li>
              </template>
              <div
                class="itemDiv"
                v-for="(itemTo, indexTo) in item.list"
                :key="indexTo"
              >
                <p>
                  {{ itemTo.title }}
                </p>
                <div>
                  <p>
                    <span v-if="itemTo.make_status == 0">未练习</span>
                    <span v-if="itemTo.make_status == 1">练习中</span>
                    <span v-if="itemTo.make_status === 2">已完成</span>
                  </p>
                  <el-button
                    type="primary"
                    class="test-btn"
                    @click="smartStart(item, itemTo.start, itemTo.title)"
                  >
                    <span v-if="itemTo.make_status == 0">开始练习</span>
                    <span v-else-if="itemTo.make_status == 1">继续练习</span>
                    <span v-else>再练一次</span>
                  </el-button>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>

        <!-- 随机练习 -->
        <div class="smartDisorderly" v-else>
          <p class="title">
            <em></em>
            <span>请选择随机出题题型</span>
            <em></em>
          </p>
          <ul class="smartDisorderlyUl">
            <li v-for="(item, index) in smartDataList" :key="index">
              <el-checkbox v-model="checkedActive" :label="item.title"
                >{{ item.title }}({{ item.total }})</el-checkbox
              >
            </li>
          </ul>
          <el-button
            v-if="this.checkedActive.length > 0"
            type="primary"
            class="test-btn"
            @click="randomStart()"
            >开始练习</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Practice from "./practiceList";
import { CourseList, TestType, TestList } from "@/api/realTest";
import { getTypeSmart, getRandomSmart, getCourseType } from "@/api/basic";
import { getStore } from "@/utils/localStorage";

export default {
  name: "allTest",
  components: { Practice },
  data() {
    return {
      profession_id: 0,
      type_id: "1",
      type_name: "历年真题",
      course_type: 1,
      course_id: "",
      // courseTypeList: [
      //   {
      //     title: "认定课程",
      //     id: 1,
      //   },
      //   {
      //     title: "国考课程",
      //     id: 2,
      //   },
      // ],
      courseTypeList: [],
      selectList: [], // 课程选择
      TestTypeList: [], //查询试卷类型
      paperLists: [], // 查询试卷列表
      // 智能练习
      smartBnt: [
        { smartActive: "orderly", bntText: "按题型练习" },
        { smartActive: "disorderly", bntText: "随机练习" },
      ],
      setSmartActive: "orderly",
      smartDataList: [],
      checkedActive: [],
    };
  },
  watch: {
    // 监听菜单切换
    "$store.state.common.menuActive": function (val) {
      val == '章节练习'?this.course_type = 2 : this.course_type = 1
      this.getTab(val);
      this.courseTypeChange();
    },
  },
  beforeRouteEnter(to, from, next) {
    // 从我的课程进入
    if (from.name == "course") {
      next((vm) => {
        let queryId = vm.$route.query.courseUuid;
        let queryType = Number(vm.$route.query.course_type);
        console.log(queryType)
        vm.course_id = queryId || "";
        vm.course_type = queryType || 1;
      });
    } else {
      next();
    }
  },
  created() {
    this.getSpecialtyCount();

    let menuActive = this.$store.state.common.menuActive;
    menuActive == '章节练习'?this.course_type = 2 : this.course_type = 1
    this.getTestType().then(() => {
      this.getTab(menuActive);
      this.getCourseList().then(() => {
        // console.log(this.selectList)
        if (!this.course_id && this.selectList.length > 0) {
          this.course_id = this.selectList[0].id;
        }
        this.getType();
      });
    });
  },
  methods: {
    // 课程类型
    async getSpecialtyCount() {
      const { result } = await getCourseType();
      if (result) {
        this.courseTypeList = result;

        if (result.length > 0) {
          this.courseType = result[0].course_type;
        }
      }
    },
    // 试卷类型
    async getTestType() {
      let majorStore = getStore("studentMajor");

      if (majorStore) {
        this.profession_id = JSON.parse(majorStore).profession_id;
      }

      const res = await TestType({ profession_id: this.profession_id });
      if (res.code === 200) {
        this.TestTypeList = res.result;
      }
    },
    /**
     * tab切换
     */
    setTypeId() {
      this.TestTypeList.forEach((item) => {
        if (item.id == this.type_id) {
          this.$store.commit("common/changeMenuMutation", { name: item.title }); //改变menuActive
        }
      });
    },
    getTab(menuActive) {
      this.TestTypeList.forEach((item) => {
        if (item.title == menuActive) {
          this.type_name = item.title;
          this.type_id = item.id + "";
        }
      });
    },
    /**
     * 课程类型切换
     */
    courseTypeChange() {
      this.getCourseList().then(() => {
        if (this.selectList.length > 0) {
          this.course_id = this.selectList[0].id;
        }else {
          this.course_id = '';
        }
        this.getType();
      });
    },
    // 课程列表
    async getCourseList() {
      const res = await CourseList({
        profession_id: this.profession_id,
        course_type: this.course_type,
        type_id: this.type_id
      });
      if (res.code === 200) {
        this.selectList = res.result;
      }
    },
    /**
     * 课程切换
     */
    courseSelect(course_id) {
      this.course_id = course_id;
      this.getType();
    },
    getType() {
      switch (this.type_name) {
        case "智能练习":
          this.setSmartType("orderly");
          break;
        default:
          this.getExamLists();
          break;
      }
    },
    /**
     * 历年真题、模拟考试列表
     */
    async getExamLists() {
      const params = {
        type_id: this.type_id,
        profession_id: this.profession_id,
        course_id: this.course_id,
        course_type: this.course_type,
      };
      const res = await TestList(params);
      if (res.code === 200) {
        this.paperLists = res.result;
      }
    },
    /**
     * 跳转
     */
    jump(id) {
      this.$router.push({
        name: "realTestStart",
        // name: 'practiceTest',
        query: {
          test_id: id,
          type: 3,
          course_id: this.course_id,
        },
      });
    },
    /**
     * 智能练习
     */
    setSmartType(val) {
      this.setSmartActive = val;
      this.getSmartData();
    },
    async getSmartData() {
      const params = {
        course_id: this.course_id,
      };

      if (this.setSmartActive === "orderly") {
        const { result } = await getTypeSmart(params);
        if (result) {
          this.smartDataList = result;
        }
        return;
      }

      const { result } = await getRandomSmart(params);
      if (result) {
        this.smartDataList = result;
      }
    },
    smartStart(item, start, title) {
      this.$router.push({
        name: "smartPractice",
        query: {
          course_id: this.course_id,
          question_style: item.style,
          total: item.total,
          start: start,
          title: title
        },
      });
    },
    randomStart() {
      this.$router.push({
        name: "startPractice",
        query: {
          course_id: this.course_id,
          question_title: this.checkedActive.join(","),
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.green {
  color: green;
}
.uni-real-test {
  padding: $boxPadding;
  padding-bottom: 0;
  min-height: $menuH;
  display: flex;
  flex-direction: column;

  .real-test-filter {
    width: 100%;
    background: #fff;
    padding: 0 20px;
    overflow: hidden;
  }

  .filter-box {
    background: #fff;

    .tit {
      width: 100px;
      font-size: 16px;
      font-weight: 600;
    }

    .con {
      flex: 1;
    }

    .filter-list {
      padding-bottom: 20px;

      .item {
        display: flex;
        border-bottom: 1px solid $grayBorder;
        padding: 20px 20px 0;

        &:last-child {
          border: none;
        }
      }

      .radio {
        margin-bottom: 20px;
        margin-top: 3px;
      }

      .course {
        border: 0;
        margin: 5px 10px 5px 0;

        &.active {
          @include fontColor("primary");
          @include bgColor("active-color");
          border-color: #c0cdff;
        }
      }
    }
  }

  .real-test-box {
    flex: 1 1 auto;
    padding: 0 $boxPadding 20px;
    margin-top: $centerMargin;
    background: #fff;

    .test-btn {
      @include uni-primary-btn(123px, 34px);
      @include linearGradient("btn-start", "btn-end");
      color: #fff;
    }

    .tab-btn {
      @include uni-primary-btn(123px, 34px);
    }

    .smart {
      .smartTab {
        margin: 25px 0 36px 25px;
      }

      .smartDisorderly {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .title {
          display: flex;
          align-items: center;
          margin-top: 7px;
          margin-bottom: 30px;

          em {
            width: 90px;
            height: 1px;
            background-color: #d8d8d8;
          }

          span {
            font-size: 18px;
            color: #333;
            margin: 0 32px;
          }
        }

        .smartDisorderlyUl {
          width: 70%;
          display: flex;
          flex-wrap: wrap;
          margin-bottom: 100px;

          li {
            width: 20%;
            margin-top: 50px;
            overflow: hidden;
            padding-right: 10px;
          }
        }
      }
    }

    .real-test-list {
      overflow: hidden;
      width: 100%;

      .item {
        width: 100%;
        margin-top: 20px;
        display: flex;
        //border: 1px solid $grayBorder;
        padding: 10px;
        align-items: center;
      }

      .itemDiv {
        width: 100%;
        height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .itemDiv {
        p {
          color: #333;
        }

        p:first-child {
          font-size: 15px;
          margin-left: 100px;
        }

        div {
          height: 100%;
          display: flex;
          align-items: center;

          p {
            margin-right: 30px;
          }
        }
      }

      .img-box {
        width: 63px;
        height: 63px;
        overflow: hidden;
        margin-right: 25px;
        border: 1px solid $grayBorder;
        @include themeIcon("exam");

        .img {
          width: 100%;
          height: 100%;
        }
      }

      .img-box1 {
        width: 63px;
        height: 63px;
        margin-right: 25px;
        border: 1px solid $grayBorder;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        p {
          width: 100%;
          height: 100%;
          @include bgColor("primary");
          opacity: 0.2;
          position: absolute;
          left: 0;
          top: 0;
        }

        span {
          font-size: 40px;
          @include fontColor("primary");
        }
      }

      .content {
        flex: 1;
        margin-right: 25px;

        .tit {
          font-size: 18px;
        }

        .info {
          color: $textGrayLight;
          margin-top: 10px;
          @extend %ellipse;

          span {
            margin-right: 30px;
          }
        }

        .iconfont {
          font-size: 16px;
          color: $textGrayLight;
          vertical-align: middle;
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
